<template>
  <div class="Content">
    <div class="Title">
      Создание УЦ
    </div>
    <div class="TypeInfo">
      Основная информация
    </div>
    <div class="Info">
      <DefaultInput
        v-model="company.data.name"
        @update:modelStatus="company.validate.name = $event"
        placeholder="Название УЦ"
        :isNull="false"
      />
      <DefaultInput
        v-model="company.data.email"
        @update:modelStatus="company.validate.email = $event"
        placeholder="Email"
        :isNull="false"
        type="email"
      />
      <!-- 
      <CustomSelect
        v-model="company.data.type"
        :options="typesEC"
        placeholder="Тип УЦ"
      />
       -->
    </div>
    <div class="TypeInfo">
      Данные о владельце
    </div>
    <div class="Info">
      <DefaultInput
        v-model="company.data.nameUser"
        @update:modelStatus="company.validate.nameUser = $event"
        placeholder="Имя"
        :isNull="false"
      />
      <DefaultInput
        v-model="company.data.surnameUser"
        @update:modelStatus="company.validate.surnameUser = $event"
        placeholder="Фамилия"
        :isNull="false"
      />
      <DefaultInput
        v-model="company.data.phone"
        @update:modelPhoneFormat="company.data.phoneFormat = $event"
        @update:modelStatus="company.validate.phone = $event"
        label="Номер телефона"
        type="phone"
        :isNull="false"
      />
      <DefaultInput v-model="company.data.addr" placeholder="Адрес" />
      <DefaultInput v-model="company.data.tg" placeholder="Telegram" />
    </div>
    <div class="Buttons">
      <button
        class="FontSize16px"
        :class="validateSuccess ? 'btn-n-yellow' : 'btn-n-yellow-disabled'"
        style="width: 231px; height: 48px"
        @click="generatePassword()"
      >
        Получить пароль для УЦ
      </button>
      <router-link
        class="btn-n-white btn-router-link FontSize16px"
        style="width: 176px; height: 48px"
        :to="{ path: '/admin/registrate-ec' }"
      >
        Вернуться назад
      </router-link>
    </div>
    <DefaultModal
      v-show="requestModalShow === 1"
      class="ModalGeneratePassword"
      rmtitle="Пароль для входа"
      rmdesc="Скопируйте пароль и отправьте его УЦ для входа в личный кабинет"
      :handleModalClose="handleCloseModal"
    >
      <template v-slot:FormBody>
        <DefaultInput
          v-model="company.data.password"
          label="Сгенерированный пароль"
          :isCopying="true"
          :isDisabled="true"
        />
      </template>
      <template v-slot:ButtonsSection>
        <button 
          style="height: 48px"
          class="btn-n-yellow FontSize16px" 
          @click.native="createEC"
        >
          Создать УЦ
        </button>
        <button
          style="height: 48px"
          class="btn-n-white-no-border FontSize16px"
          @click.native="handleCloseModal"
        >
          К редактированию
        </button>
      </template>
    </DefaultModal>
  </div>
</template>

<script>
import DefaultInput from "@/components/OctaUI/Inputs/DefaultInput.vue";
import CustomSelect from "@/components/OctaUI/Selects/CustomSelect.vue";
import DefaultModal from "@/components/DefaultModal";

import { ElNotification } from "element-plus";
import { createCompany } from "@/api/company.js";

import "@/assets/css/Repainting/Buttons.css";

export default {
  components: {
    DefaultInput,
    CustomSelect,
    DefaultModal,
  },
  data() {
    return {
      // Данные для модалки
      requestModalShow: null,

      // Заполняемая информация о компании
      company: {
        data: {
          name: null,
          email: null,
          nameUser: null,
          surnameUser: null,
          phone: null,
          phoneFormat: null,
          type: "Партнер",
          addr: null,
          tg: null,
          password: null,
        },
        validate: {
          nameValidate: false,
          emailValidate: false,
          nameUserValidate: false,
          surnameUserValidate: false,
          phoneValidate: false,
        },
      },

      // Сообщения
      msg: {
        title: {
          createEC: "УЦ успешно создано",
          createError: "Извините, произошла ошибка создания",
          serverError: "Извините, произошла ошибка на сервере",
        },
        form: {
          success: {
            title: "Успех!",
            type: "success",
            position: "bottom-right",
            customClass: "ELDefaultNotification",
          },
          error: {
            title: "Упс!",
            type: "error",
            position: "bottom-right",
            customClass: "ELDefaultNotification",
          },
        },
      },

      // Данные для селектора
      typesEC: [
        { value: "Партнер", name: "Партнер" },
        { value: "ВУЗ", name: "ВУЗ" },
        { value: "Организация", name: "Организация" },
        { value: "Гос.учреждение", name: "Гос.учреждение" },
      ],
    };
  },
  computed: {
    validateSuccess() {
      return (
        this.company.validate.name &&
        this.company.validate.email &&
        this.company.validate.nameUser &&
        this.company.validate.surnameUser &&
        this.company.validate.phone
      );
    },
  },
  methods: {
    async createEC() {
      let fullPhone =
        this.company.data.phoneFormat +
        this.company.data.phone.replace(/\D/g, "");

      try {
        const result = await createCompany({
          email: this.company.data.email,
          password: this.company.data.password,
          firstname: this.company.data.nameUser,
          lastname: this.company.data.surnameUser,
          tel: fullPhone,
          tg: this.company.data.tg,
          title: this.company.data.name,
          type: this.company.data.type,
          address: this.company.data.addr,
        });

        if (result.status === 200) {
          ElNotification({
            ...this.msg.form.success,
            message: this.msg.title.createEC,
          });

          this.handleCloseModal();

          this.$router.push("/admin/registrate-ec/");
        } else {
          ElNotification({
            ...this.msg.form.error,
            message: this.msg.title.createError,
          });
        }
      } catch (e) {
        ElNotification({
          ...this.msg.form.error,
          message: this.msg.title.serverError,
        });
      }
    },
    generatePassword() {
      this.company.data.password = Math.random()
        .toString(36)
        .slice(-8);
      this.requestModalShow = 1;
    },
    handleCloseModal() {
      this.company.data.password = null;
      this.requestModalShow = null;
    },
  },
};
</script>

<style scoped>
p,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
}
.ModalGeneratePassword:deep(.RMView) {
  width: 352px;
}
.Content {
  position: relative;
  display: flex;

  max-width: 720px;
  width: 100%;
  height: fit-content;

  padding-left: 72px;
  padding-right: 72px;

  flex-direction: column;
}
.Title {
  position: relative;
  display: flex;

  width: 100%;
  height: 42px;

  font-family: "Involve";
  font-weight: 600;
  font-size: 32px;
  line-height: 130%;
  align-items: center;
  color: #1a1a1a;

  flex-direction: column;
  align-items: flex-start;
}
.TypeInfo {
  position: relative;
  display: flex;

  width: 100%;
  height: 31px;

  font-family: "Involve";
  font-weight: 500;
  font-size: 24px;
  line-height: 130%;
  align-items: center;
  color: #1a1a1a;

  flex-direction: column;
  align-items: flex-start;

  margin-top: 40px;
}
.Info {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  align-items: flex-start;

  margin-top: 24px;
  gap: 16px;
}
.Buttons {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: row;
  align-items: flex-start;

  margin-top: 40px;
  gap: 8px;
}
.FontSize16px {
  font-size: 16px !important;
}
</style>
